import request from '@/utils/request'

export function login (data: any): any {
  return request('/login/gtpw/login', {
    method: 'POST',
    data: data
  })
}

// 旧版登录
export function sendUrl (): any {
  return request('/saas/gtpw/mchUser/sendUrl', {
    method: 'POST'
  })
}

// 用户重刷Token
export function token (): any {
  return request('/api/auth/token', {
    method: 'GET'
  })
}
